import Vue from "vue";
import VueRouter from "vue-router";
import lime from "@/lime.js";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  // 登录页面
  {
    path: "/",
    component: () => import("../views/Login.vue"),
    meta: {
      rbac: "frees",
      title: "登录",
    },
  },
  {
    path: "/login",
    component: () => import("../views/Login.vue"),
    meta: {
      rbac: "frees",
      title: "登录",
    },
  },
  {
    path: "/admin",
    component: () => import("../views/Admin.vue"),
    meta: {
      rbac: "logins",
      title: "管理后台",
    },
    children: [
      {
        path: "/admin/",
        component: () => import("../views/Admin/Console/index.vue"),
        meta: {
          rbac: "logins",
          title: "控制台",
          icon: "",
        },
      },
      {
        path: "/admin/shop_list/:menu_uuid",
        component: () => import("../views/Admin/Shop/index.vue"),
        meta: {
          rbac: "logins",
          title: "客户管理",
          icon: "",
        },
      },

      {
        path: "/admin/shop_type/:menu_uuid",
        component: () => import("../views/Admin/ShopType/index.vue"),
        meta: {
          rbac: "logins",
          title: "业务类型",
          icon: "",
        },
      },
      {
        path: "/admin/shop_develop/:menu_uuid",
        component: () => import("../views/Admin/ShopDevelop/index.vue"),
        meta: {
          rbac: "logins",
          title: "开发企业",
          icon: "",
        },
      },
      {
        path: "/admin/manage/:menu_uuid",
        component: () => import("../views/Admin/Manage/index.vue"),
        meta: {
          rbac: "logins",
          title: "员工管理",
          icon: "",
        },
      },
      {
        path: "/admin/manage_role/:menu_uuid",
        component: () => import("../views/Admin/Role/index.vue"),
        meta: {
          rbac: "logins",
          title: "角色管理",
          icon: "",
        },
      },
      {
        path: "/admin/news_type/:menu_uuid",
        component: () => import("../views/Admin/NewsType/index.vue"),
        meta: {
          rbac: "logins",
          title: "资讯分类",
          icon: "",
        },
      },

      {
        path: "/admin/news/:menu_uuid",
        component: () => import("../views/Admin/News/index.vue"),
        meta: {
          rbac: "logins",
          title: "资讯管理",
          icon: "",
        },
      },

      {
        path: "/admin/shop_news/:menu_uuid",
        component: () => import("../views/Admin/ShopNews/index.vue"),
        meta: {
          rbac: "logins",
          title: "商户新闻",
          icon: "",
        },
      },

      {
        path: "/admin/shop_login_set/:menu_uuid",
        component: () => import("../views/Admin/Set/shop_login_set.vue"),
        meta: {
          rbac: "logins",
          title: "商户登录界面",
          icon: "",
        },
      },
      {
        path: "/admin/privacy/:menu_uuid",
        component: () => import("../views/Admin/Set/privacy_set.vue"),
        meta: {
          rbac: "logins",
          title: "隐私政策",
          icon: "",
        },
      },
      {
        path: "/admin/user_service/:menu_uuid",
        component: () => import("../views/Admin/Set/user_service.vue"),
        meta: {
          rbac: "logins",
          title: "用户服务协议",
          icon: "",
        },
      },
      {
        path: "/admin/pc_ver/:menu_uuid",
        component: () => import("../views/Admin/Set/shop_pc_version.vue"),
        meta: {
          rbac: "logins",
          title: "商户PC端版本",
          icon: "",
        },
      },
      {
        path: "/admin/mobile_ver/:menu_uuid",
        component: () => import("../views/Admin/Set/shop_mobile_version.vue"),
        meta: {
          rbac: "logins",
          title: "商户移动端版本",
          icon: "",
        },
      },
      {
        path: "/admin/about/:menu_uuid",
        component: () => import("../views/Admin/Set/about.vue"),
        meta: {
          rbac: "logins",
          title: "关于我们",
          icon: "",
        },
      },
      {
        path: "/admin/manage_login_set/:menu_uuid",
        component: () => import("../views/Admin/Set/manage_login_set.vue"),
        meta: {
          rbac: "logins",
          title: "运营登录界面",
          icon: "",
        },
      },
      {
        path: "/admin/develop_customer/:menu_uuid",
        component: () => import("../views/Admin/Set/develop_customer.vue"),
        meta: {
          rbac: "logins",
          title: "第三方开发客户协议",
          icon: "",
        },
      },

      {
        path: "/admin/maintain_customer/:menu_uuid",
        component: () => import("../views/Admin/Set/maintain_customer.vue"),
        meta: {
          rbac: "logins",
          title: "第三方开发客户协议",
          icon: "",
        },
      },

      {
        path: "/admin/kefuset/:menu_uuid",
        component: () => import("../views/Admin/Set/kefu.vue"),
        meta: {
          rbac: "logins",
          title: "客服支持",
          icon: "",
        },
      },

      {
        path: "/admin/task_group/:menu_uuid",
        component: () => import("../views/Admin/TaskGroup/index.vue"),
        meta: {
          rbac: "logins",
          title: "项目管理",
          icon: "",
        },
      },

      {
        path: "/admin/task/:menu_uuid",
        component: () => import("../views/Admin/Task/index.vue"),
        meta: {
          rbac: "logins",
          title: "任务管理",
          icon: "",
        },
      },

      {
        path: "/admin/help/:menu_uuid",
        component: () => import("../views/Admin/Help/index.vue"),
        meta: {
          rbac: "logins",
          title: "帮助文档",
          icon: "",
        },
      },

      {
        path: "/admin/help_look/:menu_uuid",
        component: () => import("../views/Admin/HelpHistory/indev.vue"),
        meta: {
          rbac: "logins",
          title: "访问记录",
          icon: "",
        },
      },

      {
        path: "/admin/temp_rbac/:menu_uuid",
        component: () => import("../views/Admin/TempRbac/index.vue"),
        meta: {
          rbac: "logins",
          title: "临时授权",
          icon: "",
        },
      },

      {
        path: "/admin/liuyan/:menu_uuid",
        component: () => import("../views/Admin/Web/Liuyan/index.vue"),
        meta: {
          rbac: "logins",
          title: "留言管理",
          icon: "",
        },
      },

      {
        path: "/admin/slide/:menu_uuid",
        component: () => import("../views/Admin/Web/Slide/index.vue"),
        meta: {
          rbac: "logins",
          title: "幻灯片管理",
          icon: "",
        },
      },

      {
        path: "/admin/advert_list/:menu_uuid",
        component: () => import("../views/Admin/Advert/List/index.vue"),
        meta: {
          rbac: "logins",
          title: "广告管理",
          icon: "",
        },
      },

      {
        path: "/admin/advert_position/:menu_uuid",
        component: () => import("../views/Admin/Advert/Position/index.vue"),
        meta: {
          rbac: "logins",
          title: "广告位管理",
          icon: "",
        },
      },

      {
        path: "/admin/advert_putin/:menu_uuid",
        component: () => import("../views/Admin/Advert/PutIn/index.vue"),
        meta: {
          rbac: "logins",
          title: "投放管理",
          icon: "",
        },
      },

      {
        path: "/admin/advert_putin_history/:menu_uuid",
        component: () => import("../views/Admin/Advert/History/index.vue"),
        meta: {
          rbac: "logins",
          title: "投放记录",
          icon: "",
        },
      },

      {
        path: "/admin/category/:menu_uuid",
        component: () => import("../views/Admin/Web/Category/index.vue"),
        meta: {
          rbac: "logins",
          title: "栏目管理",
          icon: "",
        },
      },
      {
        path: "/admin/spage/:menu_uuid",
        component: () => import("../views/Admin/Web/Spage/index.vue"),
        meta: {
          rbac: "logins",
          title: "单页面",
          icon: "",
        },
      },

      {
        path: "/admin/youshi/:menu_uuid",
        component: () => import("../views/Admin/Web/Youshi/index.vue"),
        meta: {
          rbac: "logins",
          title: "单页面",
          icon: "",
        },
      },

      {
        path: "/admin/yd_business/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Business/index.vue"),
        meta: {
          rbac: "logins",
          title: "业务类型",
          icon: "",
        },
      },

      {
        path: "/admin/yd_position/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Position/index.vue"),
        meta: {
          rbac: "logins",
          title: "推荐位置",
          icon: "",
        },
      },

      {
        path: "/admin/yd_category/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Category/index.vue"),
        meta: {
          rbac: "logins",
          title: "栏目管理",
          icon: "",
        },
      },

      {
        path: "/admin/yd_grade/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Grade/index.vue"),
        meta: {
          rbac: "logins",
          title: "专家等级",
          icon: "",
        },
      },

      {
        path: "/admin/yd_savant/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Savant/index.vue"),
        meta: {
          rbac: "logins",
          title: "专家列表",
          icon: "",
        },
      },

      {
        path: "/admin/yd_savant_event/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/SavantEvent/index.vue"),
        meta: {
          rbac: "logins",
          title: "专家动态",
          icon: "",
        },
      },

      {
        path: "/admin/yd_post/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Posts/index.vue"),
        meta: {
          rbac: "logins",
          title: "专家推文",
          icon: "",
        },
      },

      {
        path: "/admin/yd_recharge_set/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/RechargeSet/index.vue"),
        meta: {
          rbac: "logins",
          title: "充值业务",
          icon: "",
        },
      },

      {
        path: "/admin/yd_service/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/Service/index.vue"),
        meta: {
          rbac: "logins",
          title: "服务管理",
          icon: "",
        },
      },

      {
        path: "/admin/yd_service_content/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/ServiceContent/index.vue"),
        meta: {
          rbac: "logins",
          title: "服务内容",
          icon: "",
        },
      },

      {
        path: "/admin/member_list/:menu_uuid",
        component: () => import("../views/Admin/Member/index.vue"),
        meta: {
          rbac: "logins",
          title: "会员管理",
          icon: "",
        },
      },

      {
        path: "/admin/yd_member_coin/:menu_uuid",
        component: () => import("../views/Admin/MemberCoin/index.vue"),
        meta: {
          rbac: "logins",
          title: "会员金币",
          icon: "",
        },
      },

      {
        path: "/admin/pay_notify/:menu_uuid",
        component: () => import("../views/Admin/PayNotify/index.vue"),
        meta: {
          rbac: "logins",
          title: "支付记录",
          icon: "",
        },
      },

      {
        path: "/admin/yd_recharge_order/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/RechargeOrder/index.vue"),
        meta: {
          rbac: "logins",
          title: "服务订单",
          icon: "",
        },
      },

      {
        path: "/admin/yd_member_post/:menu_uuid",
        component: () => import("../views/Admin/Yingdong/MemberPost/index.vue"),
        meta: {
          rbac: "logins",
          title: "推文查看",
          icon: "",
        },
      },

      {
        path: "/admin/yd_member_service/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/MemberService/index.vue"),
        meta: {
          rbac: "logins",
          title: "已购服务",
          icon: "",
        },
      },

      {
        path: "/admin/shop_account/:menu_uuid",
        component: () => import("../views/Admin/ShopAccount/index.vue"),
        meta: {
          rbac: "logins",
          title: "资金账户",
          icon: "",
        },
      },

      {
        path: "/admin/yd_set/:menu_uuid",
        component: () => import("../views/Admin/Set/yingdong.vue"),
        meta: {
          rbac: "logins",
          title: "赢动配置",
          icon: "",
        },
      },

      {
        path: "/admin/version/:menu_uuid",
        component: () => import("../views/Admin/SetManage/index.vue"),
        meta: {
          rbac: "logins",
          title: "版本控制",
          icon: "",
        },
      },

      {
        path: "/admin/nami_category/:menu_uuid",
        component: () => import("../views/Admin/Nami/Category/index.vue"),
        meta: {
          rbac: "logins",
          title: "分类管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_coach/:menu_uuid",
        component: () => import("../views/Admin/Nami/Coach/index.vue"),
        meta: {
          rbac: "logins",
          title: "教练管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_country/:menu_uuid",
        component: () => import("../views/Admin/Nami/Country/index.vue"),
        meta: {
          rbac: "logins",
          title: "国家管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_competition/:menu_uuid",
        component: () => import("../views/Admin/Nami/Competition/index.vue"),
        meta: {
          rbac: "logins",
          title: "赛事管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_competition_rule/:menu_uuid",
        component: () =>
          import("../views/Admin/Nami/CompetitionRule/index.vue"),
        meta: {
          rbac: "logins",
          title: "赛事赛制",
          icon: "",
        },
      },

      {
        path: "/admin/nami_team/:menu_uuid",
        component: () => import("../views/Admin/Nami/Team/index.vue"),
        meta: {
          rbac: "logins",
          title: "球队管理",
          icon: "",
        },
      },
      {
        path: "/admin/nami_player/:menu_uuid",
        component: () => import("../views/Admin/Nami/Player/index.vue"),
        meta: {
          rbac: "logins",
          title: "球员管理",
          icon: "",
        },
      },
      {
        path: "/admin/nami_referee/:menu_uuid",
        component: () => import("../views/Admin/Nami/Referee/index.vue"),
        meta: {
          rbac: "logins",
          title: "裁判管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_venue/:menu_uuid",
        component: () => import("../views/Admin/Nami/Venue/index.vue"),
        meta: {
          rbac: "logins",
          title: "场馆管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_honor/:menu_uuid",
        component: () => import("../views/Admin/Nami/Honor/index.vue"),
        meta: {
          rbac: "logins",
          title: "荣誉管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_season/:menu_uuid",
        component: () => import("../views/Admin/Nami/Season/index.vue"),
        meta: {
          rbac: "logins",
          title: "赛季管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_stage/:menu_uuid",
        component: () => import("../views/Admin/Nami/Stage/index.vue"),
        meta: {
          rbac: "logins",
          title: "阶段管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_match/:menu_uuid",
        component: () => import("../views/Admin/Nami/Match/index.vue"),
        meta: {
          rbac: "logins",
          title: "比赛管理",
          icon: "",
        },
      },

      {
        path: "/admin/nami_match_live/:menu_uuid",
        component: () => import("../views/Admin/Nami/MatchLive/index.vue"),
        meta: {
          rbac: "logins",
          title: "实时统计",
          icon: "",
        },
      },

      {
        path: "/admin/nami_match_stream/:menu_uuid",
        component: () => import("../views/Admin/Nami/MatchStream/index.vue"),
        meta: {
          rbac: "logins",
          title: "比赛直播",
          icon: "",
        },
      },

      {
        path: "/admin/yd_content_group/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/ContentGroup/index.vue"),
        meta: {
          rbac: "logins",
          title: "内容分组",
          icon: "",
        },
      },

      {
        path: "/admin/yd_playing_method/:menu_uuid",
        component: () =>
          import("../views/Admin/Yingdong/PlayingMethod/index.vue"),
        meta: {
          rbac: "logins",
          title: "玩法配置",
          icon: "",
        },
      },

      {
        path: "/admin/labs_func_list/:menu_uuid",
        component: () => import("../views/Admin/Labs/List/index.vue"),
        meta: {
          rbac: "logins",
          title: "功能管理",
          icon: "",
        },
      },

      {
        path: "/admin/labs_func_comment/:menu_uuid",
        component: () => import("../views/Admin/Labs/Comment/index.vue"),
        meta: {
          rbac: "logins",
          title: "功能留言",
          icon: "",
        },
      },

      {
        path: "/admin/express_company/:menu_uuid",
        component: () => import("../views/Admin/Express/Company/index.vue"),
        meta: {
          rbac: "logins",
          title: "快递公司",
          icon: "",
        },
      },

      {
        path: "/admin/express_contact/:menu_uuid",
        component: () => import("../views/Admin/Express/Contact/index.vue"),
        meta: {
          rbac: "logins",
          title: "快递联系人",
          icon: "",
        },
      },

      {
        path: "/admin/bank/:menu_uuid",
        component: () => import("../views/Admin/SystemSet/Bank/index.vue"),
        meta: {
          rbac: "logins",
          title: "银行管理",
          icon: "",
        },
      },

      {
        path: "/admin/city/:menu_uuid",
        component: () => import("../views/Admin/SystemSet/City/index.vue"),
        meta: {
          rbac: "logins",
          title: "行政区域",
          icon: "",
        },
      },

      {
        path: "/admin/harbor/:menu_uuid",
        component: () => import("../views/Admin/BaseInfo/Harbor/index.vue"),
        meta: {
          rbac: "logins",
          title: "港口管理",
          icon: "",
        },
      },

      {
        path: "/admin/wharf/:menu_uuid",
        component: () => import("../views/Admin/BaseInfo/Wharf/index.vue"),
        meta: {
          rbac: "logins",
          title: "码头管理",
          icon: "",
        },
      },

      {
        path: "/admin/ship_type/:menu_uuid",
        component: () => import("../views/Admin/BaseInfo/ShipType/index.vue"),
        meta: {
          rbac: "logins",
          title: "船只类型",
          icon: "",
        },
      },

      {
        path: "/admin/vehicle_type/:menu_uuid",
        component: () =>
          import("../views/Admin/BaseInfo/VehicleType/index.vue"),
        meta: {
          rbac: "logins",
          title: "车辆类型",
          icon: "",
        },
      },

      {
        path: "/admin/shuiyun_driving/:menu_uuid",
        component: () => import("../views/Admin/Shuiyun/Driving/index.vue"),
        meta: {
          rbac: "logins",
          title: "司机管理",
          icon: "",
        },
      },

      {
        path: "/admin/shuiyun_vehicle/:menu_uuid",
        component: () => import("../views/Admin/Shuiyun/Vehicle/index.vue"),
        meta: {
          rbac: "logins",
          title: "载具管理",
          icon: "",
        },
      },

      {
        path: "/admin/goods_type/:menu_uuid",
        component: () => import("../views/Admin/BaseInfo/GoodsType/index.vue"),
        meta: {
          rbac: "logins",
          title: "货物类型",
          icon: "",
        },
      },

      {
        path: "/admin/addr/:menu_uuid",
        component: () =>
          import("../views/Admin/BaseInfo/CommonAddress/index.vue"),
        meta: {
          rbac: "logins",
          title: "常用地址",
          icon: "",
        },
      },

      {
        path: "/admin/shipper/:menu_uuid",
        component: () => import("../views/Admin/Shuiyun/Shipper/index.vue"),
        meta: {
          rbac: "logins",
          title: "托运方管理",
          icon: "",
        },
      },

      {
        path: "/admin/carrier/:menu_uuid",
        component: () => import("../views/Admin/Shuiyun/Carrier/index.vue"),
        meta: {
          rbac: "logins",
          title: "承运方管理",
          icon: "",
        },
      },
    ],
  },
];

const router = new VueRouter({
  // mode: 'history', // 去除#号
  // base: '',
  routes,
});

// 路由守护处理,登录非登录的界面
router.beforeEach((to, from, next) => {
  let login_token = lime.cookie_get("login_token");

  if (lime.debug) {
    console.log(login_token);
  }

  if (login_token == null || typeof login_token == "undefined") {
    lime.cookie_set("login_token", null, 0);
    if (to.meta.rbac != "frees") {
      next("/login");
    } else {
      next();
    }
  } else {
    // 检测login_token是否在线
    lime
      .req("CheckLoginToken", {
        login_token: login_token,
        business_type: "manage",
        login_type: 0,
      })
      .then((res) => {
        // 更新cookie的缓存,2小时
        lime.cookie_set("login_token", login_token, 7200);
        // 默认进入页面,则自动跳转到'/admin'
        if (to.path == "/") {
          next("/admin");
        } else {
          next();
        }
      })
      .catch((err) => {
        lime.cookie_set("login_token", null, 0);
        // 检测失败,直接跳转到登录页面
        next("/login");
      });
  }
});

export default router;
